'use client'

// Overhead wires — every baked Bezier curve in wires.glb merged into a
// single lineSegments draw. They share one material and never move, so
// there's no reason to pay a draw call each. Since 30 Oct that is the 19
// first strung through the middle of town and 37 more (Sam: "connect up the
// other streetlamps too - the idea is messy sort of japanese suberb style"):
// three cables along each run of lamps, slack ones hanging lower on some
// spans, and drops from a pole to a wall. They were named one by one here
// and the new ones would never have been drawn, so every line in the file
// is taken now.

import { useMemo } from 'react'
import { useGLTF } from '@react-three/drei'
import * as THREE from 'three/webgpu'
import { mergeGeometries } from 'three/examples/jsm/utils/BufferGeometryUtils.js'

export function Wires(props) {
  const { nodes } = useGLTF('/models/wires.glb')

  // Shared black material for all wire segments
  const material = useMemo(() => {
    const mat = new THREE.LineBasicNodeMaterial()
    mat.color = new THREE.Color('#000000')
    return mat
  }, [])

  // The curves are baked in world space (the previous markup drew each with no
  // transform), so a straight merge preserves their placement.
  const { merged, fallback } = useMemo(() => {
    const geos = Object.values(nodes).filter((n) => n.isLineSegments && n.geometry).map((n) => n.geometry)
    if (!geos.length) return { merged: null, fallback: [] }
    // mergeGeometries returns null if the attribute sets disagree; keep the
    // per-curve draws in that case rather than losing the wires entirely.
    const m = mergeGeometries(geos, false)
    return m ? { merged: m, fallback: [] } : { merged: null, fallback: geos }
  }, [nodes])

  return (
    <group {...props} dispose={null}>
      {merged
        ? <lineSegments geometry={merged} material={material} />
        : fallback.map((g, i) => <lineSegments key={i} geometry={g} material={material} />)}
    </group>
  )
}

useGLTF.preload('/models/wires.glb')
